var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VueFeedback,{attrs:{"type":"success"}},[_c('template',{slot:"feedback-title"},[_vm._v(" A pályázat sikeresen benyújtásra került!")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }